// eslint-disable-next-line @typescript-eslint/no-explicit-any
type iDontKnow = any; // TODO: описать тип, когда дойдут руки

export const calculateDelta = (serverTime?: iDontKnow) => {
  return serverTime ? (Date.now() - new Date(serverTime).valueOf()) : 0;
};
